import { Button, CircularProgress, Collapse } from '@mui/material';
import Box from '@mui/material/Box';
import Icon from '@mui/material/Icon';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import i18n from 'i18next';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { baseUrl, Endpoints } from '../../api';
import { useAppDispatch } from '../../redux/hooks';
import { resetSearch, setCurrentCategory } from '../../redux/slices/productList';
import { getData, postData } from '../../redux/thunks/itemsApi';
import Style from './index.style';
import { setCategoryId, setParentCategoryId, addDeatilIdsFilter, resetParams } from '../../redux/slices/params';
import Breadcrumb from '../../components/Breadcrumbs';
import { categoryIcons } from './categoryIcons';

const url = baseUrl + Endpoints.categories;

interface BreadcrumbItem {
    id: number;
    name: string;
    next: string;
}

interface SubcategoryItem {
    id: number;
    name: string;
    parent_id?: number;
}

type SubCategoriesResponse = Record<string, SubcategoryItem[] | undefined>;

const Categories = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [subValues, setSubVulues] = useState<SubCategoriesResponse | undefined>();
    const [activePage, setActivePage] = useState(1);
    const [nextValues, setNextValues] = useState<SubcategoryItem[] | null>(null);
    const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbItem[]>([]);
    const [subCategoryLoading, setSubCategoryLoading] = useState(false);
    const [hasSalesOrRent, setHasSalesOrRent] = useState(false);

    const getCategorries = async () => {
        const res = await getData(url);
        return res;
    };

    const { data, isLoading } = useQuery('categories', getCategorries, {
        refetchOnWindowFocus: false
    });
    const getByCategoryId = async (categoryId: number, categoryName: string) => {
        setSubCategoryLoading(true);
        setBreadcrumbs([...breadcrumbs, { id: categoryId, name: categoryName, next: 'subCategory2' }]);
        dispatch(setCategoryId(categoryId));
        // dispatch(setCurrentSearch(categoryName));
        dispatch(setCurrentCategory(categoryId.toString()));
        setHasSalesOrRent(categoryId === 1 || categoryId === 2 || categoryId === 76729 || categoryId === 4);
        try {
            const response = await postData(baseUrl + Endpoints.subCategories, { id: categoryId, lang: i18n.language });
            setSubVulues(response);
            setActivePage(2);
            setSubCategoryLoading(false);
        } catch (error) {
            console.log('error of subcategoty', error);
            setSubCategoryLoading(false);
        }
    };

    const filterValuesById = (categoryId: number, next: string, name: string, parent_id?: number) => {
        // dispatch(setCurrentSearch(name));
        if (next === 'details2') {
            // dispatch(addDeatilIds(categoryId));
            // dispatch(setParentCategoryId(0));
            const params = {
                Id: categoryId,
                parentId: parent_id,
                Value: 0
            };
            dispatch(addDeatilIdsFilter(params));

            dispatch(setCategoryId(0));
            // dispatch( addDeatilIdsFilter(categoryId));
        } else if (next === 'subCategory2') {
            dispatch(setCategoryId(0));
            dispatch(setParentCategoryId(categoryId));
        } else if (next === 'details1') {
            dispatch(setCategoryId(categoryId));
            // dispatch(setParentCategoryId(categoryId));
        } else {
            dispatch(setCategoryId(categoryId));
        }

        const data = subValues?.[next] as SubcategoryItem[] | undefined;
        const nextValue = data?.filter((item) => item.parent_id === categoryId);

        if (!nextValue?.length) return;
        setNextValues(nextValue);
        if (activePage === 4) {
            // replace with last one in breadcrumbs
            //   setBreadcrumbs(breadcrumbs.slice(0, -1));
            const newBreadcrumbs = [...breadcrumbs.slice(0, -1), { id: categoryId, name, next }];
            setBreadcrumbs(newBreadcrumbs);
        } else {
            const newBreadcrumbs = [...breadcrumbs, { id: categoryId, name, next }];

            setBreadcrumbs(newBreadcrumbs);
        }
        setActivePage(next === 'subCategory2' ? 3 : 4);
    };
    const handleBreadcrumbClick = (index: number) => {
        const item = breadcrumbs[index];
        if (!item) return;
        const { id, next, name } = item;

        if (index === breadcrumbs.length - 1) {
            return;
        }
        console.log('index', index, id, next, name);
        if (next === 'subCategory2') {
            getByCategoryId(id, name);
        } else {
            filterValuesById(id, next, name);
        }
        setBreadcrumbs(breadcrumbs.slice(0, index + 1));
    };

    const handleReset = () => {
        setBreadcrumbs([]);
        setSubVulues(undefined);
        setNextValues(null);
        setActivePage(1);
        dispatch(setCategoryId(0));
        // dispatch(setCurrentSearch(''));
        dispatch(resetParams());
        dispatch(resetSearch());
    };

    const subCategory1 = subValues?.subCategory1;

    return (
        <Collapse sx={Style.categoryContainer} in={!isLoading} timeout="auto" unmountOnExit easing="cubic-bezier(0.4, 0, 0.2, 1)" onExited={handleReset}>
            <Box gap={2} sx={Style.categoryHeader}>
                <Typography sx={Style.categoryTitle} onClick={handleReset}>
                    {t('web.category-categories')}
                </Typography>
                {breadcrumbs.length > 0 && (
                    <Typography component="span" color="text.secondary" sx={{ mx: 0.5 }}>
                        /
                    </Typography>
                )}
                {<Breadcrumb items={breadcrumbs} handleClick={handleBreadcrumbClick} />}
            </Box>

            {isLoading || subCategoryLoading ? (
                <Box sx={Style.loadingContainer}>
                    <CircularProgress />
                </Box>
            ) : (
                <>
                    <Collapse easing="cubic-bezier(0.4, 0, 0.2, 1)" in={activePage === 1}>
                        <CategoryIcons data={data ?? []} getByCategoryId={getByCategoryId} />
                    </Collapse>
                    <Collapse easing="cubic-bezier(0.4, 0, 0.2, 1)" in={activePage === 2} timeout="auto" unmountOnExit>
                        {Array.isArray(subCategory1) && <Subcategories values={subCategory1} filterValuesById={filterValuesById} nextName={'subCategory2'} />}
                    </Collapse>
                    <Collapse easing="cubic-bezier(0.4, 0, 0.2, 1)" in={activePage === 3 && hasSalesOrRent} timeout="auto" unmountOnExit>
                        {Array.isArray(nextValues) && <Subcategories values={nextValues} filterValuesById={filterValuesById} nextName={'details1'} />}
                    </Collapse>
                    {/* <Collapse easing="cubic-bezier(0.4, 0, 0.2, 1)" in={activePage === 4}>
                        {Array.isArray(nextValues) && <Subcategories values={nextValues} filterValuesById={filterValuesById} nextName={'details2'} />}
                    </Collapse> */}
                </>
            )}
        </Collapse>
    );
};

export default Categories;

interface SubcategoriesProps {
    values: SubcategoryItem[];
    filterValuesById: (categoryId: number, next: string, name: string, parent_id?: number) => void;
    nextName: string;
}

const Subcategories = React.memo(({ values, filterValuesById, nextName }: SubcategoriesProps) => {
    const [activeId, setActiveId] = React.useState(0);
    return values ? (
        <Box sx={Style.categoryList}>
            {values.map((each: SubcategoryItem, index: number) => {
                const handleClick = () => {
                    const { id, name, parent_id } = each;
                    filterValuesById(id, nextName, name, parent_id);
                    setActiveId(id);
                };
                return (
                    <Button sx={activeId === each.id ? Style.active_btns : Style.sub_btns} variant={each.id === activeId ? 'contained' : 'outlined'} key={index} onClick={handleClick}>
                        {each.name}
                    </Button>
                );
            })}
        </Box>
    ) : null;
});

interface CategoryItem {
    categoryId: number;
    categoryImage?: string;
    [key: string]: string | number | undefined;
}

interface CategoryIconsProps {
    data: CategoryItem[];
    getByCategoryId?: (categoryId: number, categoryName: string) => void;
}

const CategoryIcons = ({ data, getByCategoryId }: CategoryIconsProps) => {
    return (
        <Box
            sx={(theme) => ({
                ...Style.categoryList,
                [theme.breakpoints.down('sm')]: Style.categoryListMobile
            })}
        >
            {data?.map((item: CategoryItem, index: number) => {
                if (!item) return null;

                const icon = (item.categoryImage?.split('-')[0] ?? '') as string;
                const iconTypes = ['car', 'yoga', 'teddy', 'bag', 'pier', 'star', 'basketball', 'dog', 'cog', 'tools', 'basket', 'fruit', 'gift', 'face'];
                const type = iconTypes.includes(icon) ? 'other' : 'mi';
                const label = (item[`name_${i18n.language}`] ?? '') as string;

                const handleClick = () => getByCategoryId?.(item.categoryId, label);

                return (
                    <Paper
                        key={item.categoryId ?? index}
                        elevation={3}
                        sx={(theme) => ({
                            ...Style.categoryCard,
                            [theme.breakpoints.down('sm')]: Style.categoryCardMobile,
                            '&:hover .category-icon': {
                                color: theme.palette.mode === 'dark' ? '#fff' : '#000'
                            }
                        })}
                        onClick={handleClick}
                    >
                        <Box
                            sx={(theme) => ({
                                ...Style.categoryIconContainer,
                                [theme.breakpoints.down('sm')]: Style.categoryIconWrapperMobile
                            })}
                        >
                            <Icon fontSize="large" className="category-icon" sx={Style.iconCategory}>
                                {type === 'mi' ? icon : categoryIcons?.[item.categoryId]}
                            </Icon>
                        </Box>
                        <Box
                            sx={(theme) => ({
                                ...Style.categoryTextContainer,
                                [theme.breakpoints.down('sm')]: { p: 0, m: 0, pt: 0, minWidth: 0, height: 'auto' }
                            })}
                        >
                            <Typography
                                variant="h5"
                                component="span"
                                sx={(theme) => ({
                                    ...Style.categoryText,
                                    [theme.breakpoints.down('sm')]: Style.categoryLabelMobile
                                })}
                                onClick={(e: React.MouseEvent) => {
                                    e.stopPropagation();
                                    handleClick();
                                }}
                            >
                                {label}
                            </Typography>
                        </Box>
                    </Paper>
                );
            }) ?? null}
        </Box>
    );
};
